export enum MetalsQuoteRequestStatus {
    Draft = 'Draft',
    Released = 'Released',
}
